import React, { useState } from "react";
import { styled, useStyletron } from "baseui";
import { Button } from "baseui/button";
import { ListItem, ListItemLabel, ARTWORK_SIZES } from "baseui/list";
import { HeadingSmall, ParagraphLarge } from "baseui/typography";
import { FaTimes } from "react-icons/fa";

const Container = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    height: '100%',
    maxWidth: '800px', // Increase the maxWidth of the parent container
    margin: '120px auto',
  });
const ListContainer = styled("div", {
  flex: 1, // Occupy the remaining available space in the parent container
width: '100%',
  overflowY: "auto",
  maxHeight: "600px",
});

const UserAccountOrganizationsView = () => {
  const [css] = useStyletron();
  const [organizations, setOrganizations] = useState([{
    id: 1,
    name: "Organization 1",
    role: "Owner",
  }]);
  const [newOrganizationName, setNewOrganizationName] = useState("");

  const removeOrganization = (id) => {
    setOrganizations(organizations.filter((org) => org.id !== id));
  };

  return (
    <Container>
        <HeadingSmall>Organizations List</HeadingSmall>
        <ListContainer>
          <ul
            className={css({
              width: "800px",
              paddingLeft: 0,
              paddingRight: 0,
            })}
          >
            {organizations.map((org) => (
              <ListItem key={org.id} artworkSize={ARTWORK_SIZES.LARGE}>
                <ListItemLabel description={org.role}>
                  <ParagraphLarge>{org.name}</ParagraphLarge>
                </ListItemLabel>
                <Button
                  onClick={() => removeOrganization(org.id)}
                  size="compact"
                  kind="secondary"
                  shape="pill"
                  startEnhancer={<FaTimes />}
                  overrides={{
                    BaseButton: {
                      style: ({ $theme }) => ({
                        backgroundColor: $theme.colors.negative,
                        color: $theme.colors.white,
                      }),
                    },
                  }}
                >
                  Leave
                </Button>
              </ListItem>
            ))}
          </ul>
        </ListContainer>

    </Container>        
  );
};

export default UserAccountOrganizationsView;
